import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

// Lê um File do input e devolve o conteúdo em base64 puro (sem prefixo data:).
export function lerArquivoBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function fetchRepositorios(params = {}) {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/repositorios', { headers: getAuthHeaders(), params, timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    if (err?.response?.status === 501) return [];
    console.error('Erro ao listar repositórios:', err);
    return [];
  }
}

export async function fetchRepositorio(id) {
  const base = getBase();
  if (!base || !id) return null;
  const res = await axios.get(base + '/repositorios/' + id, { headers: getAuthHeaders(), timeout: 15000 });
  return res?.data ?? null;
}

export async function createRepositorio(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/repositorios', body, { headers: getAuthHeaders() });
}

export async function updateRepositorio(id, body) {
  const base = getBase();
  if (!base || !id) throw new Error('Backend ou repositório não definido');
  const res = await axios.put(base + '/repositorios/' + id, body, { headers: getAuthHeaders(), timeout: 15000 });
  return res?.data ?? null;
}

export async function fetchCategorias() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/repositorios/categorias', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    if (err?.response?.status === 501) return [];
    console.error('Erro ao listar categorias:', err);
    return [];
  }
}

export async function createCategoria(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const res = await axios.post(base + '/repositorios/categorias', body, { headers: getAuthHeaders(), timeout: 15000 });
  return res?.data ?? null;
}

export async function updateCategoria(catId, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const res = await axios.put(base + '/repositorios/categorias/' + catId, body, { headers: getAuthHeaders(), timeout: 15000 });
  return res?.data ?? null;
}

export async function deleteCategoria(catId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/repositorios/categorias/' + catId, { headers: getAuthHeaders(), timeout: 15000 });
}

export async function fetchProjetos(repoId, categoriaId) {
  const base = getBase();
  if (!base || !repoId) return [];
  try {
    const params = categoriaId != null ? { categoria_id: categoriaId } : {};
    const res = await axios.get(base + '/repositorios/' + repoId + '/projetos', { headers: getAuthHeaders(), params, timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar projetos:', err);
    return [];
  }
}

export async function fetchRepositorioSprint(sprintId) {
  const base = getBase();
  if (!base || !sprintId) return null;
  const res = await axios.get(base + '/repositorios/sprint/' + sprintId, { headers: getAuthHeaders(), timeout: 15000 });
  return res?.data ?? null;
}

export async function fetchArquivos(repoId, params = {}) {
  const base = getBase();
  if (!base || !repoId) return [];
  try {
    const res = await axios.get(base + '/repositorios/' + repoId + '/arquivos', { headers: getAuthHeaders(), params, timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar arquivos:', err);
    return [];
  }
}

export async function fetchCommits(repoId) {
  const base = getBase();
  if (!base || !repoId) return [];
  try {
    const res = await axios.get(base + '/repositorios/' + repoId + '/commits', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar commits:', err);
    return [];
  }
}

export async function fetchVersoes(repoId, arquivoId) {
  const base = getBase();
  if (!base || !repoId || !arquivoId) return [];
  try {
    const res = await axios.get(base + '/repositorios/' + repoId + '/arquivos/' + arquivoId + '/versoes', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar versões:', err);
    return [];
  }
}

export async function commitArquivos(repoId, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/repositorios/' + repoId + '/commit', body, { headers: getAuthHeaders(), timeout: 60000 });
}

export async function restaurarVersao(repoId, arquivoId, versao) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/repositorios/' + repoId + '/arquivos/' + arquivoId + '/restaurar', { versao }, { headers: getAuthHeaders() });
}

export async function excluirArquivo(repoId, arquivoId, senhaExclusao) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const data = senhaExclusao != null && String(senhaExclusao).trim() !== ''
    ? { senha_exclusao: String(senhaExclusao).trim() }
    : {};
  return axios.delete(base + '/repositorios/' + repoId + '/arquivos/' + arquivoId, { headers: getAuthHeaders(), data });
}

export async function baixarArquivo(repoId, arquivoId, nome, versao) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const params = versao != null ? { versao } : {};
  const res = await axios.get(base + '/repositorios/' + repoId + '/arquivos/' + arquivoId + '/download', {
    headers: getAuthHeaders(), params, responseType: 'blob', timeout: 60000
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = nome || 'arquivo';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function fetchArquivoDoc(repoId, arquivoId) {
  const base = getBase();
  if (!base || !repoId || !arquivoId) return null;
  try {
    const res = await axios.get(`${base}/repositorios/${repoId}/arquivos/${arquivoId}/doc`, {
      headers: getAuthHeaders(),
      timeout: 15000,
    });
    return res?.data ?? null;
  } catch (err) {
    if (err?.response?.status === 501) return { moduloIndisponivel: true };
    throw err;
  }
}

export async function saveArquivoDoc(repoId, arquivoId, body) {
  const base = getBase();
  if (!base || !repoId || !arquivoId) throw new Error('Backend ou arquivo não definido');
  const res = await axios.put(`${base}/repositorios/${repoId}/arquivos/${arquivoId}/doc`, body, {
    headers: getAuthHeaders(),
    timeout: 30000,
  });
  return res?.data ?? null;
}

export async function fetchArquivosParaMencao(repoId, params = {}) {
  const base = getBase();
  if (!base || !repoId) return [];
  try {
    const res = await axios.get(`${base}/repositorios/${repoId}/arquivos-para-mencao`, {
      headers: getAuthHeaders(),
      params,
      timeout: 10000,
    });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    if (err?.response?.status === 501) return [];
    console.error('Erro ao buscar arquivos para menção:', err);
    return [];
  }
}

export async function fetchDocsRepositorio(repoId, params = {}) {
  const base = getBase();
  if (!base || !repoId) return [];
  try {
    const res = await axios.get(`${base}/repositorios/${repoId}/docs`, {
      headers: getAuthHeaders(),
      params,
      timeout: 15000,
    });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    if (err?.response?.status === 501) return [];
    console.error('Erro ao listar documentação:', err);
    return [];
  }
}
